import Header from './Header'
import Toolbar from './BottomNavigationBar'
import styled from '@emotion/styled'
import CustomToaster from 'src/components/CustomToaster'

type ArtistLayoutProps = {
  children?: React.ReactNode
}

const AppContainer = styled.div`
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas:
    'main'
    'footer';
  grid-template-rows: 1fr 56px;
`

const MainContentContainer = styled.main`
  overflow: overlay;
  -webkit-overflow-scrolling: touch;
  grid-area: main;
`

const ArtistLayout = ({ children }: ArtistLayoutProps) => {
  return (
    <AppContainer>
      <MainContentContainer>
        <Header />
        {children}
      </MainContentContainer>
      <CustomToaster />
      <Toolbar />
    </AppContainer>
  )
}

export default ArtistLayout
